module.exports = __webpack_public_path__ + "img/PrezenceNew.0f5b84ff.png";